var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1585 10.7201C10.0848 10.7887 10.0257 10.8715 9.98473 10.9635C9.94374 11.0555 9.9217 11.1548 9.91992 11.2555C9.91814 11.3562 9.93667 11.4563 9.97439 11.5497C10.0121 11.643 10.0683 11.7279 10.1395 11.7991C10.2107 11.8703 10.2955 11.9265 10.3889 11.9642C10.4823 12.0019 10.5823 12.0204 10.683 12.0187C10.7837 12.0169 10.8831 11.9948 10.975 11.9538C11.067 11.9128 11.1498 11.8537 11.2185 11.7801L14.4685 8.53006L14.9995 8.00006L14.4695 7.47006L11.2195 4.22006C11.0781 4.08337 10.8887 4.00769 10.6921 4.0093C10.4954 4.01092 10.3073 4.08971 10.1681 4.2287C10.029 4.36769 9.95005 4.55576 9.94825 4.75241C9.94645 4.94906 10.022 5.13854 10.1585 5.28006L12.1285 7.25006H1.74951C1.5506 7.25006 1.35983 7.32908 1.21918 7.46973C1.07853 7.61038 0.999512 7.80115 0.999512 8.00006C0.999512 8.19897 1.07853 8.38974 1.21918 8.53039C1.35983 8.67104 1.5506 8.75006 1.74951 8.75006H12.1285L10.1585 10.7201Z",
    fill: "#2173FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowRight);
export default __webpack_public_path__ + "static/media/long_arrow_right.805234e28e9da7864f10ab4e3bb20b81.svg";
export { ForwardRef as ReactComponent };